export default {
  frequentShipperAggregations: {
    frequent_shippers: {
      name: 'Frequent Shippers',
      type: 'list',
      aggregation: {
        terms: {
          size: 100000,
          field: 'shipperId.keyword',
          min_doc_count: 5
        }
      }
    }
  },
  growthAggregations: {
    jobs: {
      name: 'Jobs',
      type: 'number'
    },
    revenue: {
      name: 'Revenue',
      type: 'money',
      aggregation: {
        sum: {
          field: 'shipperTotal'
        }
      }
    },
    payouts: {
      name: 'Payouts',
      type: 'money',
      aggregation: {
        sum: {
          field: 'carrierTotal'
        }
      },
      hide: true
    },
    margin: {
      name: 'Margin',
      type: 'percentage',
    },
    jobs_per_day: {
      name: 'Jobs/Day',
      type: 'number'
    },
    revenue_per_day: {
      name: 'Revenue/Day',
      type: 'money'
    },
    average_ticket: {
      name: 'Avg.ticket',
      type: 'money',
      aggregation: {
        avg: {
          field: 'shipperTotal'
        }
      }
    },
    new_shippers: {
      name: 'New Shippers',
      type: 'number',
      aggregationType: 'bucket',
      filter: 'firstShipperShipment:true',
      aggregation: {
        filters: {
          filters: {
            'firstShipperShipment:true': {
              query_string: {
                query: 'firstShipperShipment:true',
                analyze_wildcard: true
              }
            }
          }
        }
      }
    },
    new_carriers: {
      name: 'New Carriers',
      type: 'number',
      aggregationType: 'bucket',
      filter: 'firstCarrierShipment:true',
      aggregation: {
        filters: {
          filters: {
            'firstCarrierShipment:true': {
              query_string: {
                query: 'firstCarrierShipment:true',
                analyze_wildcard: true
              }
            }
          }
        }
      }
    },
    unique_shippers: {
      name: 'Unique Shippers',
      type: 'number',
      aggregation: {
        cardinality: {
          field: "shipperId.keyword"
        }
      }
    },
    unique_carriers: {
      name: 'Unique Carriers',
      type: 'number',
      aggregation: {
        cardinality: {
          field: 'carrierId.keyword'
        }
      }
    },
    unique_drivers: {
      name: 'Unique Drivers',
      type: 'number',
      aggregation: {
        cardinality: {
          field: 'driverId.keyword'
        }
      }
    },
    total_picked_up: {
      name: 'On-time pickup',
      type: 'number',
      hide: true,
      aggregation: {
        filter: {
          bool: {
            must: [
              {term: {geoFencedAtOrigin: true}}
            ]
          }
        },
        aggs: {
          on_time_pickup: {
            filter: {
              term: {onTimeArrivalAtOrigin: true}
            }
          }
        }
      }
    },
    pickup_on_time: {
      name: 'Pickup On-time',
      type: 'percentage'
    },
    total_delivered: {
      name: 'On-time delivery',
      type: 'number',
      hide: true,
      aggregation: {
        filter: {
          bool: {
            must: [
              {term: {geoFencedAtDestination: true}},
            ]
          }
        },
        aggs: {
          on_time_delivery: {
            filter: {
              term: {onTimeArrivalAtDestination: true}
            }
          }
        }
      }
    },
    delivery_on_time: {
      name: 'Delivery On-time',
      type: 'percentage'
    },
    bol_tardiness: {
      name: 'POD',
      type: 'percentage',
      aggregation: {
        terms: {
          field: 'bolUploadTimeliness'
        }
      },
      hide: true
    },
    bol_tardiness_12hours: {
      name: 'POD < 12 hours',
      type: 'percentage'
    },
    bol_tardiness_24hours: {
      name: 'POD < 24 hours',
      type: 'percentage'
    },
    canceled: {
      name: 'Canceled',
      type: 'percentage',
      aggregation: {
        filter: {
          term: {canceled: true}
        }
      },
      hide: true
    },
    phone_use: {
      name: 'Phone Use',
      type: 'number',
      hide: true,
      aggregation: {
        filter: {
          term: {
            phoneUsed: true
          }
        }
      }
    },
    phone_used: {
      name: 'Phone Used',
      type: 'percentage'
    }
  },
  dailyAggregations: {
    jobs: {
      name: 'Jobs',
      type: 'number'
    },
    revenue: {
      name: 'Revenue',
      type: 'money',
      aggregation: {
        sum: {
          field: 'shipperTotal'
        }
      }
    },
    average_ticket: {
      name: 'Avg.ticket',
      type: 'money',
      aggregation: {
        avg: {
          field: 'shipperTotal'
        }
      }
    },
    unique_shippers: {
      name: 'Unique Shippers',
      type: 'number',
      aggregation: {
        cardinality: {
          field: "shipperId.keyword"
        }
      }
    },
    unique_carriers: {
      name: 'Unique Carriers',
      type: 'number',
      aggregation: {
        cardinality: {
          field: 'carrierId.keyword'
        }
      }
    },
    unique_drivers: {
      name: 'Unique Drivers',
      type: 'number',
      aggregation: {
        cardinality: {
          field: 'driverId.keyword'
        }
      }
    },
    total_picked_up: {
      name: 'On-time pickup',
      type: 'number',
      hide: true,
      aggregation: {
        filter: {
          bool: {
            must: [
              {term: {geoFencedAtOrigin: true}}
            ]
          }
        },
        aggs: {
          on_time_pickup: {
            filter: {
              term: {onTimeArrivalAtOrigin: true}
            }
          }
        }
      }
    },
    pickup_on_time: {
      name: 'Pickup On-time',
      type: 'percentage'
    },
    total_delivered: {
      name: 'On-time delivery',
      type: 'number',
      hide: true,
      aggregation: {
        filter: {
          bool: {
            must: [
              {term: {geoFencedAtDestination: true}},
            ]
          }
        },
        aggs: {
          on_time_delivery: {
            filter: {
              term: {onTimeArrivalAtDestination: true}
            }
          }
        }
      }
    },
    delivery_on_time: {
      name: 'Delivery On-time',
      type: 'percentage'
    },
    bol_tardiness: {
      name: 'POD',
      type: 'percentage',
      aggregation: {
        terms: {
          field: 'bolUploadTimeliness'
        }
      },
      hide: true
    },
    bol_tardiness_12hours: {
      name: 'POD < 12 hours',
      type: 'percentage'
    },
    bol_tardiness_24hours: {
      name: 'POD < 24 hours',
      type: 'percentage'
    },
    canceled: {
      name: 'Canceled',
      type: 'percentage',
      aggregation: {
        filter: {
          term: {canceled: true}
        }
      },
      hide: true
    },
    phone_use: {
      name: 'Phone Use',
      type: 'number',
      hide: true,
      aggregation: {
        filter: {
          term: {
            phoneUsed: true
          }
        }
      }
    },
    phone_used: {
      name: 'Phone Used',
      type: 'percentage'
    }
  },
  dailyCustomerAggregations: {
    jobs_by_shipper: {
      name: 'Jobs',
      type: 'number',
      aggregation: {
        terms: {
          field: 'shipperName.keyword',
          size: 100000,
          order: {
            _count: 'desc'
          }
        }
      }
    },
    jobs_by_carrier: {
      name: 'Jobs',
      type: 'number',
      aggregation: {
        terms: {
          field: 'carrierName.keyword',
          size: 100000,
          order: {
            _count: 'desc'
          }
        }
      }
    },
    revenue_by_shipper: {
      name: 'Revenue',
      type: 'money',
      aggregation: {
        terms: {
          field: 'shipperName.keyword',
          size: 100000,
          order: {
            _count: 'desc'
          }
        },
        aggs: {
          revenue: {
            sum: {
              field: 'shipperTotal'
            }
          }
        }
      }
    },
    revenue_by_carrier: {
      name: 'Revenue',
      type: 'money',
      aggregation: {
        terms: {
          field: 'carrierName.keyword',
          size: 100000,
          order: {
            _count: 'desc'
          }
        },
        aggs: {
          revenue: {
            sum: {
              field: 'carrierTotal'
            }
          }
        }
      }
    },
    revenue: {
      name: 'Revenue',
      type: 'money',
      aggregation: {
        sum: {
          field: 'shipperTotal'
        }
      }
    }
  },
  dailyLookbackAggregations: {
    revenue: {
      name: 'Revenue',
      type: 'money',
      aggregation: {
        sum: {
          field: 'shipperTotal'
        }
      }
    }
  }
};
